exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.1s ease;\n}\n.fade-enter,\n.fade-leave-to{\n  opacity: 0;\n}\n.REDEEMTOURWF {\n  order: 2;\n}\n.REDEEMVH50 {\n  order: 3 ;\n}\n.REDEEMOB50 {\n  order: 1;\n}\n.REDEEMESTATE250 {\n  order: 5;\n}\n.REDEEMCHAR50 {\n  order: 4;\n}\n.REDEEMBECK50 {\n  order: 6;\n}\n", ""]);

// exports
